import { getImageBasePath } from 'utils/generics';
import Image from 'next/image';
import * as Styles from './styles';

interface IProps {
    plans: {
        icon: string;
        title: string;
        subTitle: string;
    }[];
}

function PlanDetails({ plans }: IProps) {
    return (
        <Styles.Wrapper>
            <Styles.PlanCoverWrapper>
                <Styles.PlanCoverTitle>
                    Your ACKO protection plan covers
                </Styles.PlanCoverTitle>
                {plans.map((plan, index) => (
                    <>
                        <Styles.CoverDetailsWrapper key={plan.title}>
                            <Styles.IconFlex>
                                <Image
                                    width={'48px'}
                                    height={'48px'}
                                    alt={''}
                                    src={getImageBasePath(plan.icon)}
                                />
                            </Styles.IconFlex>
                            <Styles.TitleFlex>
                                <Styles.Title>{plan.title}</Styles.Title>
                                <Styles.SubTitle>
                                    {plan.subTitle}
                                </Styles.SubTitle>
                            </Styles.TitleFlex>
                        </Styles.CoverDetailsWrapper>
                        {index !== plans.length - 1 && <Styles.Hr />}
                    </>
                ))}
            </Styles.PlanCoverWrapper>
            <Styles.MoreReason>More reasons to love ACKO</Styles.MoreReason>
            <Styles.MoreReasonFlex>
                <Styles.MoreReasonIconFlex>
                    <Image
                        width={'48px'}
                        height={'48px'}
                        alt={''}
                        src={getImageBasePath('/icons/mpos/checkClaim.svg')}
                    />
                </Styles.MoreReasonIconFlex>
                <Styles.MoreReasonText>
                    Same day claim approvals
                </Styles.MoreReasonText>
            </Styles.MoreReasonFlex>
            <Styles.Hr1 />
            <Styles.MoreReasonFlex>
                <Styles.MoreReasonIconFlex>
                    <Image
                        width={'48px'}
                        height={'48px'}
                        alt={''}
                        src={getImageBasePath('/icons/mpos/pickupDrop.svg')}
                    />
                </Styles.MoreReasonIconFlex>
                <Styles.MoreReasonText>
                    Free pickup and drop
                </Styles.MoreReasonText>
            </Styles.MoreReasonFlex>
            <Styles.Hr1 />
            <Styles.MoreReasonFlex>
                <Styles.MoreReasonIconFlex>
                    <Image
                        width={'48px'}
                        height={'48px'}
                        alt={''}
                        src={getImageBasePath('/icons/mpos/serviceNetwork.svg')}
                    />
                </Styles.MoreReasonIconFlex>
                <Styles.MoreReasonText>
                    Real time claim tracking
                </Styles.MoreReasonText>
            </Styles.MoreReasonFlex>
        </Styles.Wrapper>
    );
}

export default PlanDetails;
